var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"row",class:{ 'is-flex': _vm.type === 'flex' },attrs:{"align":_vm.align,"justify":_vm.justify,"tag":_vm.tag,"type":_vm.type,"gutter":_vm.gutter ? 30 : _vm.gutterSmall ? 22 : _vm.customGutter}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }